import { gql } from '@apollo/client';

export const MY_RECORDINGS = gql`
  query GetMyRecordingsPaginated($offset: Int!, $limit: Int!, $from: Date, $to: Date) {
    getMyRecordingsPaginated(offset: $offset, limit: $limit, from: $from, to: $to) {
      success
      error
      totalCount
      recordings {
        id
        channelCount
        fileName
        recordingStartedAt
        recordingEndedAt
        uploadedAt
        metadata {
          createdAt
          updatedAt
        }
        recordingIsUploaded
        isBeingAnalysed
        downloadUrl
        comment
        analysis {
          id
          rpeaksCount
          success
          error
          # project_management#514: when the stored analysis was produced.
          # The metadata.updatedAt field above is written only on HUMAN edits,
          # so it never moves when an analysis is re-run — which made a
          # successful reanalysis invisible here. This is what actually changes.
          analysedAt
          # project_management#533: a failed reanalysis keeps the last good
          # result; these two say so instead of a silent stale "Success".
          lastFailedAnalysisAt
          lastAnalysisError
        }
        flags
      }
    }
  }
`;
